import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { months } from 'src/util/conversion-helpers';
import { convertToUtcDate } from 'src/util/date-helpers';

@Component({
    selector: 'date-selector',
    templateUrl: './date-selector.component.html',
    styleUrls: ['./date-selector.component.scss'],
    standalone: false
})
export class DateSelectorComponent implements OnInit, OnChanges {
  @Input() startDate: Date = new Date(2021, 0, 1);
  @Input() endDate: Date = new Date();
  @Output() selectedDateChange = new EventEmitter<Date>();

  @Input()
  public set selectedDate(v : Date) {
    this._selectedDate = v;
    this._selectedYear = this._selectedDate.getFullYear();
    this._selectedMonth = months[this._selectedDate.getMonth()];
  }
  _selectedDate: Date = new Date();

  acceptableMonths: Record<number, string[]> = {};
  
  public get years() : number[] {
    return Object.keys(this.acceptableMonths).map(y => parseInt(y));
  }
  
  public get months() : string[] {
    return this.acceptableMonths[this._selectedYear] || [];
  }

  _selectedYear: number = new Date().getFullYear() - 1;

  public get selectedYear() : number {
    return this._selectedYear;
  }

  public set selectedYear(v : number) {
    this._selectedYear = v;

    if(!this.acceptableMonths[v].includes(this._selectedMonth)) {
      this._selectedMonth = this.acceptableMonths[v][0];
    }

    this.onSelectionChange();
  }
  
  _selectedMonth: string = this.months[0];

  public get selectedMonth() : string {
    return this._selectedMonth;
  }

  public set selectedMonth(v : string) {
    this._selectedMonth = v;
    this.onSelectionChange();
  }
  
  ngOnInit(): void {
      this._selectedYear = this._selectedDate.getFullYear();
      this._selectedMonth = this.months[this._selectedDate.getMonth()];
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['startDate'] || changes['endDate']) {
      console.log(`new start date!: ${this.startDate}, new end date!: ${this.endDate}`);
      this.acceptableMonths = {};
      let currentDate = this.startDate;
      while (currentDate <= this.endDate) {
        this.acceptableMonths[currentDate.getFullYear()] = [...(this.acceptableMonths[currentDate.getFullYear()] || []), months[currentDate.getMonth()]];
        currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
      }
    }
  }

  getYearLabel = (year: number) => year.toString();
  getMonthLabel = (month: string) => month;

  onSelectionChange() {
    const monthIndex = months.indexOf(this._selectedMonth);// this.months.indexOf(this._selectedMonth);
    const selectedDate = new Date(this._selectedYear, monthIndex, 1);
    this.selectedDateChange.emit(convertToUtcDate(selectedDate));
  }
}
